import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { theDallesConfig } from "./data";

export default function TheDallesPage() {
  return <OregonCityPageTemplate config={theDallesConfig} />;
}